// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app_3cl75","title":"App_title_382G7","boardWrapper":"App_boardWrapper_ejJb-","footer":"App_footer_31xbU"};